<div
  class="one3d-summary-content one3d-custom-border-bottom"
  [ngClass]="{ 'one3d-custom-summary-scroll': fromBreakup }"
>
  <ion-row *ngFor="let specification of modelSpecifications">
    <ion-col size="6" *ngIf="specification.display">
      <span class="one3d-summary-descriptor-name">
        {{ specification.label }}
      </span>
    </ion-col>
    <ion-col
      size="6"
      *ngIf="specification.display"
      class="one3d-summary-content-right-col"
    >
      <span
        class="one3d-summary-descriptor-value"
        [ngClass]="{
          'one3d-summary-descriptor-value-bold': specification.class === 'bold'
        }"
      >
        {{ specification.value }}
      </span>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="extendedWarrantyCost != 0">
    <ion-col size="8">
      <span class="one3d-summary-descriptor-name" translate>
        SUMMARY_BREAKUP.EXTENDED_WARRANTY_COST
      </span>
    </ion-col>
    <ion-col size="4" class="one3d-summary-content-right-col">
      <span
        class="one3d-summary-descriptor-value one3d-summary-descriptor-value-bold"
      >
        {{ globalService.currencyFormatter(extendedWarrantyCost) }}
      </span>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="insurancePlanCost != 0">
    <ion-col size="8">
      <span class="one3d-summary-descriptor-name" translate>
        SUMMARY_BREAKUP.INSURANCE_COST
      </span>
    </ion-col>
    <ion-col size="4" class="one3d-summary-content-right-col">
      <span
        class="one3d-summary-descriptor-value one3d-summary-descriptor-value-bold"
      >
        {{ globalService.currencyFormatter(insurancePlanCost) }}
      </span>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="mspCost != 0">
    <ion-col size="8">
      <span class="one3d-summary-descriptor-name" translate>
        SUMMARY_BREAKUP.MAINTENANCE_SERVICE_PLAN_COST
      </span>
    </ion-col>
    <ion-col size="4" class="one3d-summary-content-right-col">
      <span
        class="one3d-summary-descriptor-value one3d-summary-descriptor-value-bold"
      >
        {{ globalService.currencyFormatter(mspCost) }}
      </span>
    </ion-col>
  </ion-row>

  <ion-row *ngIf="this.globalService.addedAccessories.length > 0">
    <ion-col size="6">
      <span class="one3d-summary-descriptor-name" translate>
        SUMMARY_BREAKUP.ADDED_ACCESSORIES
      </span>
    </ion-col>
    <ion-col size="6" class="one3d-summary-content-right-col">
      <span
        class="one3d-summary-descriptor-value one3d-summary-descriptor-value-bold"
      >
        {{
          globalService.currencyFormatter(
            accessoriesService.updateAccessoryPrice().accessories
          )
        }}
      </span>
    </ion-col>
  </ion-row>

  <ion-row *ngFor="let pack of accessoryPackages">
    <ion-col size="6">
      <span class="one3d-summary-descriptor-name">
        {{ pack.packageName | uppercase }}
      </span>
    </ion-col>
    <ion-col size="6" class="one3d-summary-content-right-col">
      <span
        class="one3d-summary-descriptor-value one3d-summary-descriptor-value-bold"
      >
        {{ globalService.currencyFormatter(pack.pack_price) }}
      </span>
      <ion-icon
        [hidden]="pack.is_default === 'yes'"
        (click)="removePackConfirmation(pack)"
        class="one3d-delete-icon one3d-summary-delete-icon"
        name="trash-outline"
      ></ion-icon>
    </ion-col>
  </ion-row>

  <div class="one3d-summary-terms one3d-key-features-info">
    <p>
      {{ showMore ? summaryDisclaimer : (summaryDisclaimer | slice : 0 : 300) }}
      <span (click)="showMore = !showMore">
        {{ showMore ? "Show less" : "Show More" }}
      </span>
    </p>
  </div>
</div>

<div
  class="one3d-summary-total one3d-custom-border-bottom one3d-custom-top-border-bottom"
>
  <ion-row>
    <ion-col size="6">
      <span class="one3d-summary-total-title" translate
        >SUMMARY_BREAKUP.TOTAL_PRICE</span
      >
    </ion-col>
    <ion-col size="6" class="one3d-summary-content-right-col">
      <span class="one3d-summary-total-value">
        {{
          globalService.currencyFormatter(
            totalPrice + this.accessoriesService.updateAccessoryPrice().packs
          )
        }}
      </span>
    </ion-col>
  </ion-row>
</div>
